import { EP_ADD_NEW_ORDER, EP_CANCEL_ORDER, EP_CANCELLED_PURCHASE, EP_CREATE_CATEGORY, EP_CREATE_PRODUCT, EP_EDIT_CATEGORY, EP_EDIT_DELI_INFO, EP_EDIT_ORDER, EP_EDIT_PRODUCT, EP_EDIT_PURCHASE, EP_FINISH_ORDER, EP_GET_ACTIVE_CATEGORY_LIST, EP_GET_ACTIVE_PRODUCTS, EP_GET_CATEGORY_LIST, EP_GET_DASHBOARD, EP_GET_EDIT_PRODUCT_DETAILS, EP_GET_EDIT_PURCHASE_INFO, EP_GET_INACTIVE_PRODUCTS, EP_GET_INSTOCK_LIST, EP_GET_MONTHLY_REPORTS, EP_GET_ORDER_LIST, EP_GET_OUTOFSTOCKS, EP_GET_POSTED_LINKS, EP_GET_PRODUCT_DETAILS, EP_GET_PRODUCT_PICTURES, EP_GET_PRODUCT_TO_PURCHASE, EP_GET_PROFIT_LOSS_CALCULATE, EP_GET_PURCHASE_DETAILS, EP_GET_PURCHASE_PRODUCTS, EP_LOCK_FINANCE, EP_ORDER_AVAILABLE_PRODUCTS, EP_ORDER_DETAILS, EP_ORDER_DETAILS_TO_EDIT, EP_PURCHASE_PRODUCT, EP_RECEIVED_PURCHASE, EP_SEND_ITEM_TO_OTHER, EP_TOGGLE_ACTIVATE_PRODUCT, EP_TOGGLE_CATEGORY_ACTIVATE, EP_UNFINISH_ORDER } from '../constants/endpointConstants';
import api from './Api';


//#region Category
const createCategory = async (categoryName) => {
    const response = await api.post(EP_CREATE_CATEGORY, {categoryName});
    return response.data;
};
const editCategory = async (formData) => {
    const response = await api.post(EP_EDIT_CATEGORY, formData);
    return response.data;
};
const toggleCategoryActivate = async (categoryId) => {
    const response = await api.post(EP_TOGGLE_CATEGORY_ACTIVATE, categoryId);
    return response.data;
};
const getCategories = async () => {
    const response = await api.get(EP_GET_CATEGORY_LIST);
    return response.data;
}
const getActiveCategories = async () => {
    const response = await api.get(EP_GET_ACTIVE_CATEGORY_LIST);
    return response.data;
}
//#endregion

//#region Product
const createProduct = async (formData) => {
    const response = await api.post(EP_CREATE_PRODUCT, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};
const getProductDataById = async (productId) => {
    const response = await api.get(`${EP_GET_PRODUCT_DETAILS}/${productId}`);
    return response.data;
}
const getEditProductDataById = async (productId) => {
    const response = await api.get(`${EP_GET_EDIT_PRODUCT_DETAILS}/${productId}`);
    return response.data;
}
const getActiveProducts = async (categoryId = "") => {
    const response = await api.get(`${EP_GET_ACTIVE_PRODUCTS}/${categoryId}`);
    return response.data;
}
const getInactiveProducts = async (formData) => {
    const response = await api.post(EP_GET_INACTIVE_PRODUCTS, formData);
    return response.data;
};
const editProduct = async (formData) => {
    const response = await api.post(EP_EDIT_PRODUCT, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};
const toggleActivateProduct = async (productId) => {
    const response = await api.post(EP_TOGGLE_ACTIVATE_PRODUCT, productId);
    return response.data;
};

const getProductPictures = async (productIds) => {
    const response = await api.post(EP_GET_PRODUCT_PICTURES, productIds);
    return response.data;
};
//#endregion

//#region Purchase
const getProductToPurchase = async (productId) => {
    const response = await api.get(`${EP_GET_PRODUCT_TO_PURCHASE}/${productId}`);
    return response.data;
}
const purchaseProduct = async (formData) => {
    const response = await api.post(EP_PURCHASE_PRODUCT, formData);
    return response.data;
};
const getPurchaseProducts = async (searchDates) => {
    const response = await api.post(EP_GET_PURCHASE_PRODUCTS, searchDates);
    return response.data;
};
const getPurchasedDetails = async (purchaseId) => {
    const response = await api.get(`${EP_GET_PURCHASE_DETAILS}/${purchaseId}`);
    return response.data;
}
const getEditPurchaseInfo = async (purchaseId) => {
    const response = await api.get(`${EP_GET_EDIT_PURCHASE_INFO}/${purchaseId}`);
    return response.data;
}
const editPurchase = async (formData) => {
    const response = await api.post(EP_EDIT_PURCHASE, formData);
    return response.data;
};
const receivedPurchasedItem = async (purchaseId) => {
    const response = await api.post(EP_RECEIVED_PURCHASE, purchaseId);
    return response.data;
};
const cancelledPurchasedItem = async (purchaseId) => {
    const response = await api.post(EP_CANCELLED_PURCHASE, purchaseId);
    return response.data;
};
//#endregion

//#region Order
const getOrderAvailableProducts = async () => {
    const response = await api.get(`${EP_ORDER_AVAILABLE_PRODUCTS}`);
    return response.data;
}
const addNewOrder = async (formData) => {
    const response = await api.post(EP_ADD_NEW_ORDER, formData);
    return response.data;
};
const editOrder = async (formData) => {
    const response = await api.post(EP_EDIT_ORDER, formData);
    return response.data;
};
const editDeliInfo = async (formData) => {
    const response = await api.post(EP_EDIT_DELI_INFO, formData);
    return response.data;
};
const getOrderDetailsToEdit = async (orderId) => {
    const response = await api.get(`${EP_ORDER_DETAILS_TO_EDIT}/${orderId}`);
    return response.data;
}
const getOrderDetails = async (orderId) => {
    const response = await api.get(`${EP_ORDER_DETAILS}/${orderId}`);
    return response.data;
}
const getOrderList = async (formData) => {
    const response = await api.post(EP_GET_ORDER_LIST, formData);
    return response.data;
};
const cancelOrder = async (orderId) => {
    const response = await api.post(EP_CANCEL_ORDER, orderId);
    return response.data;
};

const finishOrder = async (orderId) => {
    const response = await api.post(EP_FINISH_ORDER, orderId);
    return response.data;
};

const unFinishOrder = async (orderId) => {
    const response = await api.post(EP_UNFINISH_ORDER, orderId);
    return response.data;
};
//#endregion

//#region Management

const getDashboard = async () => {
    const response = await api.get(`${EP_GET_DASHBOARD}`);
    return response.data;
}

const getMonthlyReports = async (formData) => {
    const response = await api.post(`${EP_GET_MONTHLY_REPORTS}`, formData);
    return response.data;
}

const lockFinance = async () => {
    const response = await api.post(`${EP_LOCK_FINANCE}`);
    return response.data;
}

const getProfitLossCalculateData = async (formData) => {
    const response = await api.post(`${EP_GET_PROFIT_LOSS_CALCULATE}`, formData);
    return response.data;
}

const getPostedSocialLinks = async (formData) => {
    const response = await api.post(`${EP_GET_POSTED_LINKS}`, formData);
    return response.data;
}
//#endregion


export {createCategory, editCategory, toggleCategoryActivate, getCategories, getActiveCategories, createProduct, getProductDataById,
        getActiveProducts, getInactiveProducts, editProduct, getEditProductDataById, toggleActivateProduct, getProductPictures, purchaseProduct,getProductToPurchase,
        getPurchaseProducts, editPurchase, receivedPurchasedItem, cancelledPurchasedItem, getPurchasedDetails,
        getOrderAvailableProducts, addNewOrder, editOrder, getOrderDetailsToEdit, getOrderDetails, getOrderList,
        cancelOrder, getProfitLossCalculateData, finishOrder, unFinishOrder, getPostedSocialLinks, getEditPurchaseInfo,
        getMonthlyReports, lockFinance, getDashboard, editDeliInfo
}